
import globalFn from './globalsFn'
import moment from 'moment-timezone'

export default {
  /**
   * item {object}
   * item.device_id {number}
   * @desc this method append 'device_info', 'device_location' to this object;
   */
  joinDevice: function (item = {}) {
    if (!item.hasOwnProperty('device_id')) {
      return item
    }

    if (!isNaN(item.device_id) && !isNaN(item.location_id)) {
      item.device_info = item.device_name || item.info || item.device_id
      item.device_location = item.location_id

      if (item.is_kiosk) {
        item.device_link = `/machine/${item.device_id}`
      }

      if (item.is_clerk) {
        item.device_link = `/clerk/${item.device_id}`
      }

      if (item.is_mobile) {
        item.device_info = `${item.device_info} (mobile)`
      }

      if (item.is_virtual) {
        item.device_info = `${item.device_info} (virtual)`
      }
    }

    const device_id = item.device_id
    const device = _.find(this.$store.state.devices, { device_id })

    if (!_.isEmpty(device)) {
      item.device_info = device.info || item.device_info || device.device_id
      item.device_location = device.location_id
      item.location_id = device.location_id

      if (device.is_kiosk) {
        item.device_link = `/machine/${device_id}`
      }

      if (device.is_clerk) {
        item.device_link = `/clerk/${device.device_id}`
      }
    } else {
      console.log('device not found', item.device_id)
    }

    return item
  },

  /**
   * @param item {object}
   * @param item.location_id {number}
   *    or
   * @param item.device_location {number} - will be joined from joinDevice();
   * @param store - Vuex store object
   * @desc this method append 'location_name' to this object and timezone;
   */
  joinLocation: (item = {}, store) => {
    if (!item.hasOwnProperty('location_id')) return item
    const loc = _.find(store.state.locations, {location_id: item.location_id})
    if (_.isEmpty(loc)) return item
    item.location_name = loc.business_name || loc.address1 || loc.location_id
    item.timezone = loc.timezone
    return item
  },

  /**
   * @param item {object}
   * @param item.thumb_url {string}
   * @param item.last_asset_link {string}
   * @param resize {number} - box width.  150 => will parse to 150x150
   *
   * @desc this method append 'customer_image' to this object;
   */
  joinCustomerImage: (item = {}, resize) => {
    resize = Number(resize)
    const link = item.thumb_url || item.last_asset_link

    if (link) {
      item.customer_image = config.assets.paymentAssetsLink

      if (resize) {
        item.customer_image += `resize/${resize}x${resize}/`
      }

      item.customer_image += link
    } else {
      item.customer_image = '/static/images/customer_preview.png'
    }

    return item
  },

  /**
   * @param item {object}
   * @param item.asset_guid {string}
   * @param item.asset_format {string}
   *   @or
   * @param item.format {string}
   *
   * @param item.asset_rotate {number} - rotate number. Enum: 0|90|180|270
   *    @or
   * @param item.rotate {number} - rotate number. Enum: 0|90|180|270
   *
   * @param resize {number} - box width.  150 => will parse to 150x150
   *
   * @desc this method append 'asset_url' or 'asset_url_full' to this object;
   */
  joinAssetUrl: (item = {}, resize) => {
    resize = Number(resize) || '-'

    const { asset_guid, asset_format, format, asset_rotate, rotate } = item
    const _format = asset_format || format
    const _rotate = asset_rotate || rotate || 0

    if (['mp4'].includes(_format)) item.isVideo = true

    let url = ''
    if (asset_guid) {
      url = config.assets.paymentAssetsLink
      if (!item.isVideo) url += `resize/${resize}x${resize}r${_rotate}/`
      url += asset_guid + '.' + _format

      item[resize === '-' ? 'asset_url_full' : 'asset_url'] = url
    }

    return item
  },

  /**
   * @param item {object}
   * @param item.asset_guid {string}
   * @param item.asset_format {string}
   *   @or
   * @param item.format {string}
   * @param item.time_added {string}
   *
   * @param link_prefix {String}
   *
   * @desc this method append 'screenshot_url' to this object;
   */
  joinScreenshotUrl: (item = {}, link_prefix) => {
    if (!link_prefix) link_prefix = config.assets.screenLink
    const { asset_guid, asset_format, format, time_added } = item
    const _format = asset_format || format

    let url = ''
    if (asset_guid) {
      url = link_prefix
      url += asset_guid + '.' + _format
      url += '?time=' + time_added.valueOf()
      item.screenshot_url = url
    }

    return item
  },

  /**
   * @param item {object}
   * @param item.first_name {string}
   * @param item.last_name {string}
   * @param item.mobile_number {string}
   *
   * @desc this method append 'customer_display_name' to this object;
   */
  joinCustomerDisplayName: (item = {}) => {
    item.customer_display_name = item.first_name ? `${item.first_name} ${item.last_name || ''}` : item.mobile_number || ''
    if (item.mobile_number) item.mobile_number_formatted = globalFn.formatPhoneUSA(item.mobile_number)
    return item
  },

  /**
   * @param item {object}
   * @param item.icon {string}
   *
   *
   * @desc this method append 'product_icon' to this object;
   */
  joinProductLink: (item = {}) => {
    const icon = item.icon || item.product_icon
    
    item.origin_icon = icon;
    if (icon) {
      if (icon.startsWith('http')) {
        item.product_icon = icon;
      } else {
        item.product_icon = config.assets.productLink + icon;
      }
    }

    return item
  },

  /**
   * @param item {object} with different fields
   * @param fields {array} - fields to format
   * @return object with new keys like total => total_formatted
   */
  joinFormattedAmounts: (item = {}, fields = []) => {
    const format = (name) => {
      if (item.hasOwnProperty(name)) item[name + '_formatted'] = globalFn.stringifyUsd(item[name])
    }

    format('actual_amount')
    format('original_amount')
    format('requested_amount')
    format('fee')
    format('fee_withdraw')
    format('caset_amount')
    format('reject_amount')
    format('coin_amount')
    format('cash_amount')
    format('payment_amount')
    format('referral_total_amount')
    format('referral_dispensed_amount')
    format('referral_amount')
    format('dispenser_cassette')
    format('dispenser_reject')

    fields.forEach(field => format(field))
  },

  /**
   * @param item {object}
   * @param item.app_id {string}
   *
   * @desc this method append 'app_name' to this object;
   */
  joinApplication: (item = {}) => {
    const app = _.find(store.state.apps, {app_id: Number(item.app_id)})
    if (app) {
      item.app_name = app.name
    }
    return item
  },

  /**
   * @param item {object}
   * @param item.first_name {string}
   * @param item.last_name {string}
   * @param item.username {string}
   *
   * @desc this method append 'customer_display_name' to this object;
   */
  joinUserDisplayName: (item = {}) => {
    item.user_display_name = item.first_name ? `${item.first_name} ${item.last_name || ''}` : item.username || ''
    return item
  },

  // /**
  //  * @param item {object}
  //  * @param item.terminal_id {number}
  //  *
  //  * @desc this method append 'terminal_processor_id', 'device_id' to this object;
  //  */
  // joinTerminal: (item = {}) => {
  //   const terminal = DB['terminals'].findOne({terminal_id: item.terminal_id}) || {};
  //   item.terminal_processor_id = terminal.processor_terminal_id;
  //   item.device_id = terminal.device_id;
  //   return item;
  // },

  /**
   * @param item {object}
   * @param item.guid {string}
   */
  joinReceiptLink (item = {}) {
    item.receipt_link = config.assets.receiptLink + item.guid
    item.receipt_html_link = item.receipt_link + '/html'
    return item
  },


  /**
   * This method will join `name_formatted_local`, `name_formatted_user` fields;
   * @param item - {object} - it should contain device_id or location_id;
   * @param options {object}
   * @param options.dateOnly {boolean} - will join `_dateonly_user` and local fields
   * @param options.format {string}
   * @return {*}
   */
  joinFormattedTime (item, options = {}, fields = []) {
    if (_.isArray(options)) {
      fields = options
      options = {}
    }

    const { format = fields[1] || 'MM/DD/YYYY hh:mm:ssa', dateOnly = false } = options || {}

    const state = this.$store.state

    if (!state) {
      console.error('joinFormattedTime, context broken')
      return item
    }

    const userTimeZone = (state.users[0] || {}).time_zone
    let localTimeZone = userTimeZone

    if (!userTimeZone) {
      console.error('joinFormattedTime, cant get timezone')
      return
    }

    let location_id = null
    if (_.isNumber(item.location_id)) location_id = item.location_id
    else if (_.isNumber(item.device_id)) {
      const device = _.find(state.devices, { device_id: item.device_id }) || {}
      location_id = device.location_id
    }

    if (_.isNumber(location_id)) {
      const loc = _.find(state.locations, { location_id })
      if (loc && loc.timezone) localTimeZone = loc.timezone
    }

    [
      'appear_time',
      'available_date',
      'available_time',
      'create_time',
      'call_request.create_time',
      'created_at',
      'created_date',
      'created_time',
      'creation_time',
      'completed_at',
      'extraction_time',
      'dispensed_time',
      'change_time',
      'dtime',
      'expiration_date',
      'file_last_update_time',
      'insert_time',
      'insertion_time',
      'last_seen',
      'system_last_seen',
      'last_update',
      'last_hard_update',
      'status_time',
      'time',
      'time_added',
      'time_created',
      'time_end',
      'timestamp',
      'time_start',
      'x_time_added',
      'wk_expired_time',
      'status_time',
      'response_time',
      ...fields
    ].forEach(field => {
      if (!_.get(item, field)) return
      const data = _.get(item, field);
      _.set(item, field, new Date(data)) // for watchers
      //throw field time_start_formatted_local not defined in console
      _.set(item ,field + '_formatted_user', moment.utc(data).tz(userTimeZone).format(format))
      _.set(item, field + '_formatted_local', moment.utc(data).tz(localTimeZone).format(format))

      if (dateOnly) {
        _.set(item, field + '_dateonly_user', moment.utc(data).tz(userTimeZone).format('MM/DD/YYYY'))
        _.set(field + '_dateonly_local', moment.utc(data).tz(localTimeZone).format('MM/DD/YYYY'))
      }
    })

    return item
  },

  /**
   * @param item
   * @param item.partner_id {Number}
   * @param store
   */
  joinPartnerName (item = {}, store) {
    if (item.hasOwnProperty('partner_id')) {
      const partner = _.find(store.state.partners, { partner_id: item.partner_id }) || {}
      item.partner_name = partner.partner_name
    }
    return item
  },

  /**
   * @param item
   * @param item.payment_id {Number}
   * @param store
   */
  joinPayment (item = {}, store) {
    if (!item.payment_id) return item
    const payment = _.find(store.state.payments, { payment_id: item.payment_id })
    if (_.isEmpty(payment)) {
      console.error(`Payment ${item.payment_id} not found for`, item)
      return item
    }

    item.device_id = payment.device_id
    item.location_id = payment.location_id
    return item
  },

  /**
   * @param item
   * @param item.session_id {Number}
   * @param store
   */
  joinSession (item = {}, store) {
    if (!item.session_id) return item
    const sessions = _.concat(store.state.sessions_1w, store.state.sessions);
    const session = _.find(sessions, { session_id: item.session_id })
    if (_.isEmpty(session)) {
      console.error(`Session ${item.session_id} not found for`, item)
      return item
    }

    item.device_id = session.device_id
    item.location_id = session.location_id
    return item
  },

  formatSessionDuration(item) {
    const session_duration_minutes = Math.floor(item.session_duration / 60);
    const session_duration_seconds = Math.floor(item.session_duration % 60);
    item.session_duration_formatted = `${session_duration_minutes ? session_duration_minutes + 'm' : ''}${session_duration_seconds}s`;

    return item;
  },

  formatBits (number) {
    if (!number) return ' - '
    number = Number(number)
    let format = 'bits'
    if (number > 1000000) {
      number = number / 1000000
      format = 'Mbits'
    } else if (number > 1000) {
      number = number / 1000
      format = 'Kbits'
    }
    return number.toFixed(2) + ' ' + format
  },

  hideFieldsDeep,

}


function hideFieldsDeep (obj, fields) {
  if (_.isArray(obj)) return _.map(obj, function (el) {
    return hideFieldsDeep(el, fields);
  });

  if (!_.isObject(obj)) return obj;

  const clone = {};
  _.each(obj, function (val, key) {
    if (_.includes(fields, key)) clone[key] = '****';
    else clone[key] = hideFieldsDeep(val, fields);
  });

  return clone;
}



// WEBPACK FOOTER //
// ./src/helpers.js